import { css } from 'styled-components';
import { FontAddiFamilyPrimaryName, FontAddiFormatTrueType, FontAddiFamilyPrimaryUrlRegular, FontAddiFamilyPrimaryUrlBold, FontAddiFamilyPrimaryUrlBoldItalic, FontAddiFamilyPrimaryUrlItalic, FontAddiWeightSemiBold, FontAddiWeightBold, FontAddiWeightMedium, FontAddiWeightRegular, FontAddiWeightExtraBold, FontAddiWeightLight, FontAddiWeightExtraLight, FontAddiWeightThin, } from '@addi/foundation/dist/web/fonts';
const PrimaryFontFaces = css `

    /* Primary - Normal */
    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlRegular}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightRegular};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlBold}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightSemiBold};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlBold}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightBold};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlBold}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightExtraBold};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlRegular}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightMedium};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlRegular}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightLight};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlRegular}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightExtraLight};
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlRegular}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightThin};
        font-style: normal;
        font-display: swap;
    }

    /* Primary - Italic */
    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightRegular};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlBoldItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightSemiBold};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlBoldItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightBold};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlBoldItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightExtraBold};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightMedium};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightLight};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightExtraLight};
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: '${FontAddiFamilyPrimaryName}';
        src: url(${FontAddiFamilyPrimaryUrlItalic}) format('${FontAddiFormatTrueType}');
        font-weight: ${FontAddiWeightThin};
        font-style: italic;
        font-display: swap;
    }

`;
export const primaryFontFamilyURLs = [
    FontAddiFamilyPrimaryUrlRegular,
    FontAddiFamilyPrimaryUrlBold,
    FontAddiFamilyPrimaryUrlBoldItalic,
    FontAddiFamilyPrimaryUrlItalic
];
export default PrimaryFontFaces;
//# sourceMappingURL=Primary.js.map